import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { DependencySecurityClient, dependencySecurityApiRef } from './api';
import { rootRouteRef } from './routes';
import { DEPENDENCY_SECURITY_ROUTES } from './navigation';

const dependencySecurityApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: dependencySecurityApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DependencySecurityClient({ discoveryApi, fetchApi }),
    }),
});

const dependencySecurityPage = PageBlueprint.make({
  params: {
    path: DEPENDENCY_SECURITY_ROUTES.root.path,
    title: DEPENDENCY_SECURITY_ROUTES.root.title,
    routeRef: rootRouteRef,
    // The finding list and detail pages render their own BUI
    // <FullPage>/<Header>.
    noHeader: true,
    loader: () =>
      import('./components/DependencySecurityPage').then(m => (
        <m.DependencySecurityPage />
      )),
  },
});

export const dependencySecurityPlugin = createFrontendPlugin({
  pluginId: 'dependency-security',
  title: DEPENDENCY_SECURITY_ROUTES.root.title,
  routes: {
    root: rootRouteRef,
  },
  extensions: [dependencySecurityApi, dependencySecurityPage],
});

export default dependencySecurityPlugin;
